<div class="grid grid-cols-3 gap-10">
  <div class="row-span-2">
    <app-card>
      <h3 class="font-bold">{{ 'page.tag-detail-info.details.title' | translate }}</h3>

      <div class="mt-2 -mx-6">
        <app-detail-entry-field label="{{ 'page.tag-detail-info.details.list.icon' | translate }}">
          <ng-container *ngIf="tag$ | async as tag">
            <img [attr.src]="tag | tagIconPreview | async" class="w-10 h-10 rounded-full border border-gray-300 overflow-hidden object-center object-cover">
          </ng-container>
        </app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.tag-detail-info.details.list.name' | translate }}">{{ (tag$ | async)?.name }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.tag-detail-info.details.list.color' | translate }}">
          <div class="w-5 h-5 rounded-full border border-gray-300" [style.background]="(tag$ | async)?.color"></div>
        </app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.tag-detail-info.details.list.created-at' | translate }}">{{ (tag$ | async)?.createdAt | date:'dd-MM-yyyy HH:mm' }}</app-detail-entry-field>
      </div>
    </app-card>
  </div>
</div>
